import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { pagesAPI } from '../api';
import { useSettings } from '../contexts/SettingsContext';

const CustomPage = () => {
  const { slug } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { settings } = useSettings();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  // Get slug from URL params or from path
  const getSlugFromPath = () => {
    if (slug) return slug;
    // Extract slug from direct paths like /kariyer, /kvkk
    const path = location.pathname.replace('/', '');
    return path;
  };

  useEffect(() => {
    const pageSlug = getSlugFromPath();
    
    // Redirect to Gallery component if slug is "galeri"
    if (pageSlug === 'galeri') {
      navigate('/galeri', { replace: true });
      return;
    }
    
    loadPage();
  }, [slug, location.pathname]);

  // Update title when page loads
  useEffect(() => {
    if (page) {
      document.title = `${page.title} - ${settings.site_name || 'Cinefora'}`;
    }
  }, [page, settings.site_name]);

  const loadPage = async () => {
    try {
      const pageSlug = getSlugFromPath();
      const response = await pagesAPI.getBySlug(pageSlug);
      setPage(response.data);
    } catch (error) {
      console.error('Error loading page:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0a]">
        <Header />
        <div className="container mx-auto px-6 py-32 text-center">
          <p className="text-white text-xl">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="min-h-screen bg-[#0a0a0a]">
        <Header />
        <div className="container mx-auto px-6 py-32 text-center">
          <h1 className="text-4xl font-bold text-white mb-4">Sayfa Bulunamadı</h1>
          <p className="text-gray-400">Aradığınız sayfa mevcut değil.</p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Header />
      <div className="container mx-auto px-6 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">{page.title}</h1>
        <div className="text-gray-300 space-y-4 max-w-4xl whitespace-pre-line">
          {page.content}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CustomPage;
